import { ELanguagePreference } from "@frontend-shared/types";

import { isOplotFlavor } from "@/env/env";

import type { IFlavorConfig } from "./types";

const NODESHIFT_FLAVOR_CONFIG: IFlavorConfig = {
  appName: "NodeShift AI",
  companyName: "NodeShift",
  defaultLanguage: ELanguagePreference.EN,
  enterpriseUrl: "https://nodeshift.com",
  enterpriseContactUrl: "https://nodeshift.com/contact",
  meetingBotEmail: "john@nodeshift.ai",
};

const OPLOT_FLAVOR_CONFIG: IFlavorConfig = {
  appName: "Oplot AI",
  companyName: "Oplot",
  defaultLanguage: ELanguagePreference.RU,
  enterpriseUrl: null,
  enterpriseContactUrl: null,
  meetingBotEmail: "oplot@oplot.ai",
};

export const FLAVOR_CONFIG: IFlavorConfig = isOplotFlavor()
  ? OPLOT_FLAVOR_CONFIG
  : NODESHIFT_FLAVOR_CONFIG;
